import { com } from '@eidu/form'
import entityApiUrl from '../baseUrl'
import requireAuthContext from '../../authorization/requireAuthContext'
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

export type DeleteEntityTypeParameters = {
  id: EntityTypeId
}

const deleteEntityType = async ({ id }: DeleteEntityTypeParameters): Promise<void> => {
  const authContext = await requireAuthContext()
  return fetch(`${entityApiUrl}/organizations/${authContext.organizationId}/types/${id.toString()}`, {
    headers: { Authorization: `Bearer ${authContext.accessToken}` },
    method: 'DELETE',
  }).then(async (response) => {
    if (response.status !== 200)
      throw Error(`Unexpected response code ${response.status} from deleteEntityType endpoint`)
  })
}

export default deleteEntityType
